import React, { useState, useEffect } from 'react'
import {
    isEmpty, map, addIndex, curry, pathOr, compose, sortBy, prop, propOr, toUpper,
} from 'ramda'
import { connect } from 'react-redux'
import { toggleItemCorrectedPrice } from '../actions/agreements_page'
import { dateString, lowestNth, sliceToWhiteSpace } from '../utilities/util'
import InactiveItemWarning from '../Reusable/InactiveItemWarning'

const mapIndexed = addIndex(map)
const lowestInt = lowestNth(1)

const computeMargin = (cost, sellPrice) => lowestInt((1 - cost / sellPrice) * 100)

// const getBestCostWithSource = (itemExpDate, itemContracts) => {

//     const filterEligible = filter(prop('isEligible'))
//     /* Ramda's lte seems to behave nicely when comparing two moment dates */
//     const afterEndDate = compose(lte(itemExpDate), prop('endDate'))
//     const filterEndDates = filter(anyPass([afterEndDate, prop('isPurchasePrice')]))
//     const sortByPrice = sortBy(prop('price'))
//     const pickDetails = pick(['price', 'contractEntity', 'isPurchasePrice', 'type', 'baseGpo', 'tier'])
//     const findCost = compose(pickDetails, head, sortByPrice, filterEndDates, filterEligible)

//     return findCost(itemContracts) || {}
// }
// const getBestCost = compose(pathOr('', ['price']), getBestCostWithSource)

const renderPriceAgreement = curry((targetMargin, getBestCostWithSource, toggleCorrectedPrice, accountAgreementId, accountAgreements, priceAgreement, index) => {
    const {
        _id, sellPrice, expDate, name, externalId, isInactive, correctedPrice, correctedSellPrice, item
    } = priceAgreement
    console.log('priceAgreement', priceAgreement)
    
    const contracts = pathOr([], ['contracts'])(priceAgreement)
    const cost = pathOr('', ['price'], getBestCostWithSource(expDate, contracts))
    const formattedCost = isEmpty(cost) ? `$${cost}` : `$${cost.toFixed(2)}`

    const sourceDetails = getBestCostWithSource(expDate, contracts)
    const sourceIdentifier = pathOr('', ['contractEntity'])(sourceDetails)
    const baseGpo = pathOr('', ['baseGpo'])(sourceDetails)
    const tier = pathOr('', ['tier'])(sourceDetails)
    const isPurchasePrice = pathOr(false, ['isPurchasePrice'])(sourceDetails)
    const type = isPurchasePrice ? 'Purchase Price' : compose(toUpper, pathOr('', ['type']))(sourceDetails)

    // Determine which price to display based on correctedPrice flag
    const displayPrice = correctedPrice && correctedSellPrice ? correctedSellPrice : sellPrice;
    const currentMargin = computeMargin(cost, displayPrice);
    const slicedExternalId = sliceToWhiteSpace(externalId)
    const formattedDate = dateString(new Date(expDate))

    return (
        <li key={index}>
            <div className="col-2">{slicedExternalId}</div>
            <div className="col-3 alignLeft bolder">
                {name}
                {isInactive && <InactiveItemWarning />}
            </div>
            <div className="col-1 price-container">
                <div >
                    <span 
                        className={`sell-price-value ${correctedPrice ? 'corrected' : ''}`} 
                        title={correctedPrice && correctedSellPrice 
                            ? "The selected margin will always be respected and the price will evolve with cost changes"
                            : "This is the agreed price and will not change"
                        }
                    >
                        &#36;{parseFloat(displayPrice).toFixed(2)}
                    </span>
                  
                </div>
            </div>
            <div className={`col-1 ${(currentMargin < targetMargin) ? 'under' : 'over'}TargetMargin`}>
                {currentMargin}&#37;
                <p>&#40;{targetMargin}&#37;&#41;</p>
            </div>
            <div className="col-2">{formattedCost}</div>
            <div className="col-1">
                {type}
                <p>{sourceIdentifier}</p>
            </div>
            <div className="col-1">
                {baseGpo}
                <p>{tier}</p>
            </div>
            <div className="col-1">{formattedDate}</div>
        </li>
    )
})

const renderPriceAgreements = compose(mapIndexed, renderPriceAgreement)

const AgreementItems = (props) => {
    const { accountAgreement, getBestCostWithSource, toggleCorrectedPrice, accountAgreements } = props

    const { targetMargin, _id: accountAgreementId } = accountAgreement
    const priceAgreements = propOr([], 'priceAgreements')(accountAgreement)
    const sortedAgreements = sortBy(prop('externalId'))(priceAgreements)

    return (
        <div>
            <div className="headerBasicList">
                <div className="col-2">ID</div>
                <div className="col-3">Name</div>
                <div className="col-1">Price</div>
                <div className="col-1">Margin</div>
                <div className="col-2">Cost</div>
                <div className="col-1">Source</div>
                <div className="col-1">GPO</div>
                <div className="col-1">Expiration Date</div>
            </div>
            <div className="basicList unLinked">
                <ul>
                    {accountAgreement && priceAgreements && renderPriceAgreements(targetMargin, getBestCostWithSource, toggleCorrectedPrice, accountAgreementId, accountAgreements)(sortedAgreements)}
                </ul>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    accountAgreements: state.accountAgreements
})

const mapDispatchToProps = {
    toggleCorrectedPrice: toggleItemCorrectedPrice
}

export default connect(mapStateToProps, mapDispatchToProps)(AgreementItems)
